import React from "react";
import DonationForm from "../components/Donations/DonationForm";
// import DonationInfo from "../components/Donations/DonationInfo";

const Donations = () => {
  return (
    <div className="donations-page">
      {/* Hero Section */}
      <section className="hero-section text-center py-5">
        <div className="container">
          <h1 className="display-4">Make a Difference Today</h1>
          <p className="lead text-white">
            Your contribution helps us bring positive change.
          </p>
        </div>
      </section>

      {/* Donation Form Section */}
      <section className="donation-form-section py-4">
        <div className="container d-flex justify-content-center">
          <DonationForm />
        </div>
      </section>
      {/* <DonationInfo /> */}
    </div>
  );
};

export default Donations;
